module.exports = __webpack_public_path__ + "img/fill.90533935.webp";